export enum ReservationSystem {
    GYG = 'GYG',
    VIATOR = 'VIATOR',
    HEADOUT = 'HEADOUT',
    TTG = 'THE TOUR GUY',
    ALL = 'ALL',
}
